// extracted by mini-css-extract-plugin
module.exports = {"box":"relatedArticle-module--box--h5bwf","title":"relatedArticle-module--title--PEYWF","boximage":"relatedArticle-module--boximage--3vx2T"};